module.exports = __webpack_public_path__ + "img/product_98.f6e6796.webp";